// extracted by mini-css-extract-plugin
module.exports = {"icon-btn":"iconBtns_icon-btn__lNvmG","heart-icon-btn":"iconBtns_heart-icon-btn__HHugZ"};